import { useMemo } from 'react';
import { Outlet, useMatches } from 'react-router';

import {
  BreadcrumbComponent,
  FlyBreadcrumbs,
} from '../FlyBreadcrumbs/FlyBreadcrumbs';

export const BaseLayout = () => {
  const matches = useMatches();

  const breadcrumbs: BreadcrumbComponent[] = useMemo(
    () =>
      matches
        .filter((match: any) => match.handle?.Breadcrumb)
        .map((match: any) => match.handle?.Breadcrumb),
    [matches]
  );
  return (
    <div className='flex h-full w-full flex-col gap-fly-4'>
      <FlyBreadcrumbs breadcrumbs={breadcrumbs} />
      <Outlet />
    </div>
  );
};
